import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-949f5f90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scopes" }
const _hoisted_2 = { class: "flex itemscenter justify-between mt-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl" }, "Фильтры", -1))
const _hoisted_4 = { class: "ScopesFilters__row" }
const _hoisted_5 = { class: "ScopesFilters__actions" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_8 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scopes_actions = _resolveComponent("scopes-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_scopes_list_item = _resolveComponent("scopes-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_scopes_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.createScope,
          onUpdate: _ctx.updateScope
        }, null, 8, ["loading", "is-create", "is-update", "initial-value", "onCreate", "onUpdate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Скоупы" }),
        _createVNode(_component_the_button, {
          class: "primary small",
          onClick: _ctx.startCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить скоуп ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("form", {
        class: "ScopesFilters mt-3",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchScope && _ctx.searchScope(...args)), ["prevent"]))
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_the_input, {
            value: _ctx.filters_state.scope,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.scope) = $event)),
            placeholder: "Название"
          }, null, 8, ["value"]),
          _createVNode(_component_the_select, {
            value: _ctx.filters_state.is_active,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.is_active) = $event)),
            options: _ctx.active_options,
            "select-by": "value",
            label: "name",
            class: "mt-2"
          }, null, 8, ["value", "options"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_the_button, {
            class: "second text small mr-3",
            disabled: _ctx.state.is_loading,
            onClick: _ctx.resetFilters
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_the_button, {
            class: "primary text small",
            loading: _ctx.state.is_loading,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode(" Поиск ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.state.scopes.is_failed && !_ctx.state.scopes.failure.error_state.is_cancel)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.scopes.is_loading,
              text: "При получении списка скоупов произошла ошибка",
              "error-message": _ctx.state.scopes.failure.error_state.message,
              "error-url": _ctx.state.scopes.failure.error_state.url,
              "error-status": _ctx.state.scopes.failure.error_state.status,
              onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadScopes(_ctx.state.scopes.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_list, {
              key: 1,
              loading: _ctx.state.scopes.is_loading,
              items: _ctx.state.scopes.list,
              pagination: "",
              "pagination-current-page": _ctx.state.scopes.pagination.current_page,
              "pagination-total-pages": _ctx.state.scopes.pagination.total_pages,
              onChangePage: _ctx.loadScopes
            }, {
              item: _withCtx(({ item }) => [
                _createVNode(_component_scopes_list_item, {
                  item: item,
                  onUpdate: _ctx.startUpdate
                }, null, 8, ["item", "onUpdate"])
              ]),
              _: 1
            }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
      ])
    ])
  ], 64))
}